var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.873,
    viewBox: "0 0 20 15.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 15.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M2.169-4.656h.423v-7.407H2.169Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M4.514-4.656h.423v-7.407H4.514Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M6.858-4.656h.423v-7.407H6.858Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M9.2-4.656h.423v-7.407H9.2Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.547-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M13.891-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M16.235-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M3.341-4.656h.423v-7.407H3.341Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M5.686-4.656h.423v-7.407H5.686Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M8.03-4.656h.423v-7.407H8.03Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M10.375-4.656H10.8v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M12.719-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M15.063-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M17.407-4.656h.423v-7.407h-.423Z",
    fill: "#00b3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.471-13.545h.423v-2.116a.212.212,0,0,0-.212-.212H17.566v.423h1.9Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M19.577-2.328v1.9h-1.9V0h2.116A.212.212,0,0,0,20-.212V-2.328Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M.423-15.45h1.9v-.423H.212A.211.211,0,0,0,0-15.661v2.116H.423Z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M.423-2.328H0V-.212A.212.212,0,0,0,.212,0H2.328V-.423H.423Z",
    fill: "#00b3ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCode);
export default __webpack_public_path__ + "static/media/projectCode.96a1476a09cdff3e4ffc0d1bf3e270c5.svg";
export { ForwardRef as ReactComponent };